import { useEffect, useState } from "react";
import { catGroups, featureList, hotTrends } from "@/mocks/trending";

const navItems = [
  { href: "#board", label: "今日热榜" },
  { href: "#feed", label: "栏目速览" },
  { href: "#features", label: "深度盘点" },
  { href: "#news", label: "疯传现场" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [kw, setKw] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const results = (() => {
    if (!kw.trim()) return [];
    const q = kw.trim().toLowerCase();
    const fromTrends = hotTrends.filter((t) => t.title.includes(q)).map((t) => t.title);
    const fromCat = catGroups.flatMap((g) => g.items).filter((i) => i.title.includes(q)).map((i) => i.title);
    const fromFeat = featureList.filter((f) => f.title.includes(q)).map((f) => f.title);
    return [...new Set([...fromTrends, ...fromCat, ...fromFeat])].slice(0, 6);
  })();

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="flex h-16 md:h-[72px] w-full items-center justify-between px-4 md:px-8 lg:px-14">
        <a href="#top" className="flex items-center gap-2 shrink-0" aria-label="吃瓜爆网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className={`font-heading text-xl font-bold tracking-wide ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
            吃瓜<span className="text-primary-500">爆网</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  : "text-background-50/90 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {n.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setSearchOpen(true)}
            aria-label="搜索全网热点"
            className={`flex h-9 w-9 items-center justify-center rounded-full transition-colors ${
              scrolled ? "text-foreground-800 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </button>
          <a
            href="#subscribe"
            className={`hidden whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors sm:inline-flex ${
              scrolled ? "bg-primary-500 text-background-50 hover:bg-primary-600" : "bg-primary-500/90 text-background-50 hover:bg-primary-500"
            }`}
          >
            订阅每日精选
          </a>
          <button
            onClick={() => setOpen(!open)}
            aria-label="展开菜单"
            className={`flex h-9 w-9 items-center justify-center rounded-full md:hidden ${
              scrolled ? "text-foreground-800 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <div className="flex flex-col gap-1 pt-3">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
            <a href="#subscribe" onClick={() => setOpen(false)} className="mt-2 rounded-full bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50">
              订阅每日精选
            </a>
          </div>
        </div>
      )}

      {searchOpen && (
        <div className="fixed inset-0 z-[60] flex flex-col bg-background-950/60 backdrop-blur-sm" onClick={() => setSearchOpen(false)}>
          <div className="mx-auto mt-[9vh] w-[92%] max-w-xl" onClick={(e) => e.stopPropagation()}>
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-sm">
              <div className="flex items-center gap-2 border-b border-background-200 px-4 py-3">
                <i className="ri-search-line text-primary-500" aria-hidden="true"></i>
                <input
                  autoFocus
                  value={kw}
                  onChange={(e) => setKw(e.target.value)}
                  placeholder="搜热点、搜梗、搜事件…"
                  className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
                />
                <button onClick={() => setSearchOpen(false)} aria-label="关闭搜索" className="text-foreground-500 hover:text-foreground-950">
                  <i className="ri-close-line text-lg" aria-hidden="true"></i>
                </button>
              </div>
              <div className="max-h-72 overflow-auto p-2">
                {kw.trim() && results.length === 0 && (
                  <p className="px-3 py-6 text-center text-sm text-foreground-500">没有找到相关热点，换个关键词试试</p>
                )}
                {!kw.trim() && (
                  <div className="px-3 py-3">
                    <p className="mb-2 text-xs text-foreground-500">热门搜：</p>
                    <div className="flex flex-wrap gap-2">
                      {["村咖", "宿舍爆改", "方言翻唱", "占座", "反内卷"].map((s) => (
                        <button
                          key={s}
                          onClick={() => setKw(s)}
                          className="rounded-full border border-background-200 px-3 py-1 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                        >
                          {s}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                {results.map((r) => (
                  <a
                    key={r}
                    href="#feed"
                    onClick={() => {
                      setSearchOpen(false);
                      setKw("");
                    }}
                    className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    <i className="ri-corner-down-right-line text-foreground-400" aria-hidden="true"></i>
                    {r}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}